import React, { useContext } from "react";
import DetailHead from "./DetailsHead";
import "../../styles/EventDetails.css";
import marketingbg from "../../assets/details/ic_bg.png";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";

const EventJudges = ({ judges }) => {
  const { language } = useContext(LanguageContext);
  return (
    <div className="judges_details">
      <div className="et_pb_section judges_section et_pb_section_parallax et_pb_with_background et_section_regular section_has_divider judges_bottom_divider judges_top_divider">
        <div className="judges_top_inside_divider"> </div>
        <div className="et_parallax_bg_wrap">
          <div
            className="et_parallax_bg"
            style={{
              backgroundImage: `url(${marketingbg})`,
              height: "100%",
            }}
          ></div>
        </div>
        <div className="container">
          <div
            className="row"
            style={{
              justifyContent: "center",
            }}
          >
            <DetailHead title={TEXT[language]["SUSTAINATHONS"]["10"]} />
            {judges ? (
              judges.map((judge, index) => (
                <div
                  key={index}
                  data-aos="zoom-in-down"
                  data-aos-delay="0"
                  data-aos-duration="800"
                  // data-aos-anchor-placement="top-center"
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-12 judge-card text-center"
                  // className="column1 judge_column  et_pb_column_8 et_pb_css_mix_blend_mode_passthrough"
                >
                  <div className="module judge_team_member judge_team_member_0 et_hover_enabled clearfix et_pb_text_align_center et_pb_bg_layout_light et_had_animation">
                    {judge.imageUrl ? (
                      <div className="judge_team_member_image et-waypoint et_pb_animation_off et-animated">
                        <img
                          className="judge-img"
                          src={judge.imageUrl}
                          sizes="(min-width: 327px) 800px, 400px"
                          alt="judge"
                          width="225px"
                          height="247px"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="judge_team_member_description">
                      <h4 className="judge_header">{judge.name}</h4>
                      <p style={{}} className="judge_member_position">
                        {judge.designation}
                        <br />
                        <span
                          className="judge_company"
                          style={{
                            fontWeight: "600",
                          }}
                        >
                          {" "}
                          {judge.company}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <h3>{TEXT[language]["SUSTAINATHONS"]["5"]}</h3>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventJudges;
